import { getApiReactHooks } from '@frontend/api-client';
import { baseApi } from '@frontend/web/redux';

export const {
  useAcceptComplexityPricingMutation,
  useBuyCreditsMutation,
  useChangeEmailMutation,
  useChangePasswordMutation,
  useClaimLowCreditBonusMutation,
  useClerkSSOLoginMutation,
  useCloseTaskMutation,
  useConfirmDoneMutation,
  useCreateAddressMutation,
  useCreateClientMutation,
  useCreateCommentMutation,
  useCreateDraftTaskMutation,
  useCreateGeneralFeedbackMutation,
  useCreateInviteMutation,
  useCreateMCPSocialAuthMutation,
  useCreateRecurrenceMutation,
  useCreateSecureNoteMutation,
  useCreateSetupIntentMutation,
  useCreateTaskFromDraftTaskMutation,
  useCreateTaskMutation,
  useCreateTaskReviewMutation,
  useCreateWaitlistContactMutation,
  useDeactivateOAuthAccountMutation,
  useDeleteCardMutation,
  useDeleteClientMutation,
  useDeleteDraftTaskMutation,
  useDeleteRecurrenceMutation,
  useDeleteSecureNoteMutation,
  useDismissAllCalendarRecurrencesMutation,
  useDismissCalendarRecurrenceMutation,
  useEditDraftTaskAfterFailureMutation,
  useEditProfileMutation,
  useExpireInviteMutation,
  /** @deprecated We're moving away from timeslots */
  useForgotPasswordMutation,
  useFrictionlessSignupMutation,
  useFrictionlessSSOSignupMutation,
  useGenerateDraftTaskTimeSlotsMutation,
  useGetShareUrlMutation,
  useGiftTaskMutation,
  useLazyAddressAutocompleteQuery,
  useLazyAddressDetailsQuery,
  useLazyAuthenticateImageKitQuery,
  useLazyListCardsQuery,
  useLazyListCommentsQuery,
  useLazyListDraftTasksQuery,
  useLazyListExamplesQuery,
  useLazyListPurchasesQuery,
  useLazyListRecurrencesQuery,
  useLazyListSecureNotesQuery,
  useLazyListTaskSearchResultsQuery,
  useLazyRetrieveClientQuery,
  useLazyRetrieveClientStatusQuery,
  useLazyRetrieveCreditsQuery,
  useLazyRetrieveDraftTaskQuery,
  useLazyRetrieveFullLedgerReportQuery,
  useLazyRetrieveHouseholdQuery,
  useLazyRetrieveInviteQuery,
  useLazyRetrieveMCPSocialAuthQuery,
  useLazyRetrievePlansQuery,
  useLazyRetrievePlanTiersQuery,
  useLazyRetrievePromotionDetailsQuery,
  useLazyRetrieveRecurrenceQuery,
  useLazyRetrieveReferrerDetailsQuery,
  useLazyRetrieveSecureNoteContentQuery,
  useLazyRetrieveTaskQuery,
  useListAddressesQuery,
  useListCalendarRecurrencesQuery,
  useListCardsQuery,
  useListCommentsQuery,
  useListDraftTasksQuery,
  useListExamplesQuery,
  useListLetterRecommendationsQuery,
  useListOAuthAccountsQuery,
  useListRecurrencesQuery,
  useListSecureNotesQuery,
  useListSuggestionsQuery,
  useListTasksQuery,
  useLoginMutation,
  useMarkLetterRecommendationAsViewedMutation,
  usePredictRecurrenceMutation,
  usePreviewTaskQuery,
  useReengagementActivateMutation,
  useRemoveMemberFromHouseholdMutation,
  useReplaceSecureNoteContentMutation,
  useResetPasswordMutation,
  useRetrieveClientQuery,
  useRetrieveClientStatusQuery,
  useRetrieveCreditsQuery,
  useRetrieveDraftTaskQuery,
  useRetrieveFullLedgerReportQuery,
  useRetrieveHouseholdQuery,
  useRetrieveInviteQuery,
  useRetrieveLetterRecommendationQuery,
  useRetrieveNotificationSettingsQuery,
  useRetrieveOptionSheetQuery,
  useRetrievePlansQuery,
  useRetrievePlanTiersQuery,
  useRetrieveRecurrenceQuery,
  useRetrieveReferralsQuery,
  useRetrieveSecureNoteContentQuery,
  useRetrieveTaskQuery,
  useRetrieveWaitlistStatusQuery,
  useReviewOptionSheetMutation,
  useSetupIntentConfirmedMutation,
  useShareRecurrenceMutation,
  useShareTaskMutation,
  useSkipTaskMutation,
  useStartTaskMutation,
  useSubmitDraftTaskIQAnswersMutation,
  useTriggerSingleChoiceOptionMutation,
  useUnshareRecurrenceMutation,
  useUnshareTaskMutation,
  useUpdateAddressMutation,
  useUpdateCardMutation,
  useUpdateDefaultCardMutation,
  useUpdateDraftTaskMutation,
  useUpdateNotificationSettingsMutation,
  useUpdateOAuthCodeMutation,
  useUpdatePlanMutation,
  useUpdateTaskMutation,
} = getApiReactHooks(baseApi);
